import { crops, ICrop, IOmniaShell, ISeedStock, IVariety, shell, StockType } from "../../omnia"
import { TypedStockEditCtrl } from "../editTypedStock"


export class SeedStockEditCtrl extends TypedStockEditCtrl {

    static create(): ng.IDirective {

        return TypedStockEditCtrl.create(SeedStockEditCtrl, "app/stocks/edit/seeds/editSeeds.html")

    }

    private seedStock: ISeedStock

    private crops: ICrop[]
    private _crop: ICrop

    private varieties: IVariety[]
    private _variety: IVariety

    static $inject = ["$scope", "OmniaShell"]

    constructor($scope: ng.IScope, shell: IOmniaShell) {
        super($scope, shell)
    }

    protected setup() {


        this.seedStock = <ISeedStock>this.stock

        this.crops = this.stocks.getCrops()

        if (this.seedStock) {

            this.crop = this.seedStock.Crop
            this.variety = this.seedStock.Variety

            this.requiredAmount = crops.convertThousandSeedsToKg(this.seedStock.ReqdAmount, this.seedStock.TGW)

        }

    }

    protected getStockType(): StockType {
        return StockType.Seed
    }

    get crop() {
        return this._crop
    }

    set crop(value: ICrop) {

        if (value != this._crop) {
            this.varieties = (value ? value.Varieties : [])
            this._crop = value
            this._variety = null
        }

    }

    get variety(): IVariety {
        return this._variety
    }

    set variety(value: IVariety) {
        this._variety = value
    }

    canChangeCrop(): boolean {
        return (!this.isUsedInPlans())
    }

    canChangeVariety(): boolean {
        return this.crop && (!this.isUsedInPlans())
    }

    setDefaultCropAttrs() {

        if (this.newStock && this.crop) {
            this.seedStock.TGW = this.crop.TGW
            this.seedStock.GerminationRate = this.crop.GerminationRate
        }

    }

    hasSeedRateModel() {
        return this.crop && (!!this.crop.SeedRatesModel)
    }

    hasRequiredAmount() {
        return this.seedStock && (this.seedStock.ReqdAmount > 0)
    }

    checkUniqueName(): boolean {

        var stocks = this.stocks.getStocks().filter(s => !!s.SeedStockId)
        var stocks = stocks.filter(s => s.SeedStockId !== this.stock.SeedStockId)

        return stocks.filter(s => s.Name.toLowerCase().trim() === this.stock.Name.toLowerCase().trim()).length === 0
    }

    public canCommit(): boolean {

        if (!(this.form && this.form.$valid)) {
            return false
        }

        return true
    }

    commit(): ng.IPromise<any> {

        if (!this.checkUniqueName()) {
            const title = "Duplicate stock name"
            const msg = `The stock name must be unique. Another stock is already named '${this.stock.Name}'.`
            shell.showWarning(this.shell, msg, title)
            return undefined
        }

        let model = this.prepareCommitModel(this.seedStock)

        model.Crop = this.crop
        model.CropId = this.crop ? this.crop.CropId : undefined
        model.Variety = this.variety
        model.VarietyId = this.variety ? this.variety.CropVarietyId : undefined

        return this.stocks.editSeedStock(model)

    }

}
